// extracted by mini-css-extract-plugin
export default {"pagination":"pagination_pagination__C6aoZ","page":"pagination_page__3Nv0Y","active":"pagination_active__P+EfP","disabled":"pagination_disabled__iwItw"};